import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchInventoryDetail, fetchInventoryHistory, fetchInventoriesDetails, updateFilter, handleInventoryClick, updateReceiveTableFilter, fetchReceiveHistory, fetchReceiveHistoryFilterInitial } from '../../actions/inventories_actions';
import { quickAdjustment, resetQuickInventoryAdjustments } from '../../actions/inventoryAdjustments_actions';
import { fetchProductDetail, fetchCRVValues, editProduct, setValue } from '../../actions/products_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import InventoryDetail from '../../components/Inventories/inventoryDetail'
import { fetchZones, fetchBins, resetBins, } from '../../actions/zones_actions';


let inventoryDetail = reduxForm({
  form: 'inventoryDetail',
  enableReinitialize: true
})(InventoryDetail)

let selector = formValueSelector('inventoryDetail');

function mapStateToProps(state) {
    const RefPriceValue = selector(state, 'RefPrice');
    const ConvertType = selector(state, 'ConvertType');
    const zoneID = selector(state, 'Default_WarehouseZone_id');

    return {
        RefPriceValue,
        ConvertType,
        zoneID,

        currentInventoryDetail: state.inventories.currentInventoryDetail,
        currentProduct: state.products.currentProduct,
        currentProductDetail: state.products.currentProductDetail,
        initialValues: state.products.currentProductDetail,
        detailIsLoading: state.inventories.detailIsLoading,
        error: state.inventories.detailError,
        currentInventory: state.inventories.currentInventory,
        quickInventoryAdjustmentIsEditing: state.inventoryAdjustments.quickInventoryAdjustmentIsEditing,
        quickInventoryAdjustmentEdited: state.inventoryAdjustments.quickInventoryAdjustmentEdited,
        quickInventoryAdjustmentEditError: state.inventoryAdjustments.quickInventoryAdjustmentEditError,
        inventoryBatchLogDetail: state.inventoryAdjustments.inventoryBatchLogDetail,
        productReceiveHistory: state.inventoryAdjustments.productReceiveHistory,
        filterUpdated: state.inventoryAdjustments.filterUpdated,
        receiveTableFilterUpdated: state.inventoryAdjustments.receiveTableFilterUpdated,

        CRVs: state.products.CRVs,
        CRVsIsLoading: state.products.CRVsIsLoading,
        CRVsError: state.products.CRVsError,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,

        inventoryHistory: state.inventories.inventoryHistory,
        inventoryHistoryIsLoading: state.inventories.inventoryHistoryIsLoading,
        inventoryHistoryError: state.inventories.inventoryHistoryError,

        zones: state.zones.all,
        zoneError: state.zones.error,
        zoneIsLoading: state.zones.isLoading,
        bins: state.zones.bins,
        binError: state.zones.binError,
        binIsLoading: state.zones.binIsLoading,
    };
}

export default connect(mapStateToProps, {
  fetchZones, fetchBins, resetBins,
  fetchInventoryDetail, fetchInventoryHistory, quickAdjustment, resetQuickInventoryAdjustments, fetchProductDetail,
  fetchCRVValues, editProduct, checkPassword, clearCheckPassword, setValue, fetchInventoriesDetails, updateFilter, handleInventoryClick,
  updateReceiveTableFilter, fetchReceiveHistory, fetchReceiveHistoryFilterInitial
})(inventoryDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryDetail.jsx